import { createEffectHook } from '../factories/createEffectHook'
import { TypedEvent } from '../models/TypedEvent'

import type { TypedNode } from '../models/TypedNode'
import type { ViewModel } from '../models/ViewModel'
import type { Store } from '../stores/Store'

export interface TransformEventConstructor {
  new (
    ...args: any[]
  ): TypedEvent<Store | TypedNode | ViewModel, TransformEventDetail>
}

interface TransformEventDetail {
  oldValue: any
  value: any
}

/**
 * 当系统中发生类型转换时触发
 */
export class TransformEvent extends TypedEvent<
  Store | TypedNode | ViewModel,
  TransformEventDetail
> {
  type = 'onTransform' as const
}

export const { onTransform, onTransformCapture } =
  createEffectHook(TransformEvent)

declare global {
  export interface RehajeTypedEvents {
    onTransform: TransformEvent
  }
}
